/**
 * Orden estándar de tallas para prendas
 */

const SIZE_ORDER = [
  'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL',
  '2', '4', '6', '8', '10', '12', '14', '16', '18', '20',
  'PEQUEÑO', 'MEDIANO', 'GRANDE', 'EXTRA GRANDE',
  'PEQUEÑA', 'MEDIANA', 'GRANDE',
];

/**
 * Ordena un array de objetos por size_code según el orden estándar de tallas
 * @param {Array} items - Array de objetos con size_code
 * @returns {Array} Array ordenado
 */
export const sortBySizeCode = (items) => {
  if (!items || !Array.isArray(items)) return [];
  const orderMap = new Map(SIZE_ORDER.map((s, i) => [s.toUpperCase(), i]));
  return [...items].sort((a, b) => {
    const codeA = (a.size_code || a.size || '').toString().toUpperCase();
    const codeB = (b.size_code || b.size || '').toString().toUpperCase();
    const idxA = orderMap.has(codeA) ? orderMap.get(codeA) : 999;
    const idxB = orderMap.has(codeB) ? orderMap.get(codeB) : 999;
    if (idxA !== idxB) return idxA - idxB;
    return codeA.localeCompare(codeB);
  });
};
